/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Box } from "@mui/material"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import { Loading } from "components"
import { useSelector } from "react-redux"
import { Link as RouterLink } from "react-router-dom"
import { UserSlice } from "store"

export const NotFoundPage = () => {
	const loading = useSelector(UserSlice.selectors.selectLoading)
	const classPrefix = "notFoundPage"
	const containerPrefix = `${classPrefix}-container`
	const contentPrefix = `${containerPrefix}-content`
	const classes = {
		root: `${classPrefix}`,
		container: `${containerPrefix}`,
		content: `${contentPrefix}`,
		header: `${contentPrefix}-header`,
		oops: `${contentPrefix}-oops`,
		blurb: `${contentPrefix}-blurb`,
		button: `${contentPrefix}-button`,
	}

	/* eslint-disable-next-line*/
	const NotFoundPageRoot = styled("div")(({ theme }) => ({
		[`& .${classes.container}`]: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		[`& .${classes.content}`]: {
			textAlign: "center",
		},
		[`& .${classes.header}`]: {
			fontSize: "5rem",
			lineHeight: "5rem",
			fontWeight: "800",
		},
		[`& .${classes.oops}`]: {
			fontWeight: "600",
			color: theme.palette.primary.main,
			margin: "0",
		},
		[`& .${classes.blurb}`]: {
			margin: "0",
		},
		[`& .${classes.button}`]: {
			margin: "36px",
		},
	}))

	if (loading) return <Loading />

	return (
		<NotFoundPageRoot>
			<Box
				alignItems="center"
				className={classes.container}
				display="flex"
				flexDirection="column"
			>
				<h1 className={classes.header}>Oops that does not exist!</h1>
				<Button component={RouterLink} to="/" variant="contained" color="primary">
					Go Home
				</Button>
			</Box>
		</NotFoundPageRoot>
	)
}
